export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Curated%20fashion%20and%20lifestyle%20products%20arranged%20in%20an%20artistic%20flat%20lay%20collage%20with%20canvas%20sneakers%20linen%20shirts%20leather%20accessories%20and%20woven%20bags%20on%20warm%20terracotta%20and%20cream%20textured%20background%20soft%20natural%20sunlight%20editorial%20photography%20rich%20earthy%20tones%20organic%20composition%20textile%20textures%20visible%20elegant%20minimal%20aesthetic&width=1800&height=1000&seq=hero-bg-v2-2026&orientation=landscape"
        alt="ItaobuySpreadsheet product sourcing tools"
        title="ItaobuySpreadsheet - Product Sourcing Spreadsheet Tool"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full text-center px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight max-w-3xl mx-auto">
          ItaobuySpreadsheet
        </h1>
        <p className="font-heading text-xl md:text-2xl lg:text-3xl italic font-medium text-white/90 mt-3">
          The Smartest Product Sourcing Tool
        </p>
        <p className="text-sm md:text-base text-white/75 mt-6 max-w-xl mx-auto leading-relaxed">
          Discover, compare, and track products efficiently using the powerful
          <strong> itaobuyspreadsheet system</strong> designed for global
          sourcing, dropshipping, and e-commerce optimization.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-950 font-medium text-sm rounded-full hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line w-5 h-5 flex items-center justify-center"></i>
            Explore ItaobuySpreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 border border-white/40 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-eye-line w-5 h-5 flex items-center justify-center"></i>
            View Live Spreadsheet Demo
          </a>
        </div>
      </div>
    </section>
  );
}